export default function determineParent(data: any) {
    try {
        if (data.children && data.children.length > 0) {
            data.children.forEach((child: any) => {
                child.parent = data;
                determineParent(child);
            });
        }
    } catch (err) {
        console.error(err);
    }
}
